<template>
    <v-form ref="form">
        <v-layout row wrap>
            <v-flex xs12 md7 lg6>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-text-field
                            v-model="formData.title"
                            name="screener-title"
                            :label="$t('screener.quick.event.creation.step.form.field.title')"
                            :rules="[ rules.required]"
                            id="screener-title"
                            outline
                            small
                            dense
                            hide-details
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 class="mt-4">
                        <text-editor
                            :title="$t('screener.quick.event.creation.step.form.field.description')"
                            v-model="formData.description">
                        </text-editor>
                    </v-flex>
                </v-layout>
                <v-layout class="mt-3 mb-3" row wrap>
                    <v-flex class="px-1" xs6>
                        <DateTimePicker key="screening_starts_at"
                            :label="$t(`screener.save.form.starts_at`)" datetime="screening_starts_at"
                            v-model="formData.screening_starts_at" />

                        <!-- Showing local time regarding company configured timezone -->
                        <ShowLocalTime v-if="formData.screening_starts_at"
                            key="screening_starts_at_local" :datetime="formData.screening_starts_at"
                            :timezone="timezone"></ShowLocalTime>
                    </v-flex>
                    <v-flex class="px-1" xs6>
                        <DateTimePicker key="screening_starts_at"
                            :label="$t(`screener.save.form.ends_at`)" datetime="screening_ends_at"
                            v-model="formData.screening_ends_at" />

                        <!-- Showing local time regarding company configured timezone -->
                        <ShowLocalTime v-if="formData.screening_ends_at" key="screening_ends_at_local"
                            :datetime="formData.screening_starts_at" :timezone="timezone">
                        </ShowLocalTime>
                    </v-flex>
                </v-layout>
                <!-- <v-layout row wrap>
                    <v-flex xs6 class="px-1">
                        <v-text-field v-model="formData.max_participants" name="screener-title"
                            :label="$t('screener.quick.event.creation.step.form.field.max.participants')"
                            id="id" outline small dense hide-details type="number"></v-text-field>
                    </v-flex>
                </v-layout> -->
            </v-flex>
            <v-flex xs12 md5 lg6 class="pl-4">
                <v-layout column justify-space-between fill-height>
                    <v-flex>
                        <v-layout v-if="!videoSource && videoInDraftMode && videoInDraftMode.vimeoId" column>
                            <v-flex>
                                <v-card
                                    v-if="videoUploader.isUploading || videoUploader.status == 'complete'"
                                    hover
                                    :class="[
                                        'video-uploader',
                                        'd-flex',
                                        'align-center',
                                        'justify-center',
                                    ]"
                                    height="200px"
                                    max-height="200px"
                                >
                                    <div class="text-xs-center">
                                        <div v-if="videoUploader.isUploading">
                                            <span class="grey--text text--darken-2">{{ uploadingVideoStatus}}</span>
                                        </div>
                                        <v-img v-if="videoUploader.status == 'complete' && videoUploader.thumbnailUrl" contain :src="videoUploader.thumbnailUrl"></v-img>

                                        <!-- <v-btn class="change-video-btn" outline flat small width="100%" color="primary">{{ $t('screener.quick.event.creation.step.form.video.upload.change.video.btn') }}</v-btn> -->
                                    </div>
                                </v-card>
                                <v-card
                                    v-else
                                    hover
                                    :class="[
                                        'video-uploader',
                                        'd-flex',
                                        'align-center',
                                        'justify-center',
                                        videoSource == DEFINES.QUICK_EVENT.VIDEO_SOURCE.UPLOAD ?'video-source-selected' :''
                                    ]"
                                    height="200px"
                                >
                                    <div class="pa-2">
                                        <div>
                                            <v-alert outline type="success" :value="true">Success! Your video has been uploaded.</v-alert>
                                        </div>
                                    </div>
                                </v-card>
                                <input type="file" accept="video/*" ref="videoFilePicker" @change="onVideoSelection" :style="{ display: 'none' }">
                                <v-card-actions>
                                    <v-btn style="width: 100%;" @click="openFilePicker('video_movie')" width="100%" small color="warning">Change Video</v-btn>
                                </v-card-actions>
                                <h3 class="grey--text text--darken-2">Note: </h3>
                                <template v-if="videoInDraftMode && videoInDraftMode.uploadingVideoStatus == 'in_progress'">
                                    <p class="grey--text text--darken-2">
                                        {{ $t('quick.event.background.video.processing.message') }}
                                    </p>
                                </template>
                                <template v-else>
                                    <p class="grey--text text--darken-2">
                                        {{ $t('quick.event.successful.upload.message.for.publish') }}
                                    </p>
                                </template>
                            </v-flex>
                        </v-layout>
                        <v-layout v-else column>
                            <v-flex>
                                <v-card
                                    v-if="videoUploader.isUploading || videoUploader.status == 'complete'"
                                    hover
                                    :class="[
                                        'video-uploader',
                                        'd-flex',
                                        'align-center',
                                        'justify-center',
                                    ]"
                                    height="200px"
                                    max-height="200px"
                                >
                                    <div class="text-xs-center">
                                        <div v-if="videoUploader.isUploading">
                                            <span class="grey--text text--darken-2">{{ uploadingVideoStatus}}</span>
                                        </div>
                                        <v-img v-if="videoUploader.status == 'complete' && videoUploader.thumbnailUrl" contain :src="videoUploader.thumbnailUrl"></v-img>

                                        <!-- <v-btn class="change-video-btn" outline flat small width="100%" color="primary">{{ $t('screener.quick.event.creation.step.form.video.upload.change.video.btn') }}</v-btn> -->
                                    </div>
                                </v-card>
                                <v-card
                                    v-else
                                    hover
                                    :class="[
                                        'video-uploader',
                                        'd-flex',
                                        'align-center',
                                        'justify-center',
                                        videoSource == DEFINES.QUICK_EVENT.VIDEO_SOURCE.UPLOAD ?'video-source-selected' :''
                                    ]"
                                    height="200px"
                                    @click="openFilePicker('video_movie')"
                                >
                                    <div class="text-xs-center">
                                        <v-icon large color="primary">mdi-cloud-upload</v-icon>
                                        <div>
                                            <span class="grey--text text--darken-2">{{$t('screener.quick.event.creation.step.form.field.uploader.message')}}</span>
                                        </div>
                                    </div>
                                </v-card>
                                <input type="file" accept="video/*" ref="videoFilePicker" @change="onVideoSelection" :style="{ display: 'none' }">
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap v-if="!videoUploader.status && !videoInDraftMode">
                            <v-flex xs12>
                                <h3 class="grey--text text--grey text-xs-center py-4">or</h3>
                            </v-flex>
                            <v-flex xs12>
                                <v-card
                                    @click="changeVideoSource(DEFINES.QUICK_EVENT.VIDEO_SOURCE.SAMPLE)"
                                    hover
                                    :class="[
                                        'pa-1',
                                        videoSource == DEFINES.QUICK_EVENT.VIDEO_SOURCE.SAMPLE ?'video-source-selected' :''
                                    ]"
                                    max-height="80px"
                                >
                                    <v-layout row wrap>
                                        <v-flex xs2>
                                            <img contain :src="sampleVideo.thumbnailUrl" :style="{borderRadius:'8px', height: '100%', objectFit: 'cover', width: '100%'}"/>
                                        </v-flex>
                                        <v-flex xs9>
                                            <v-layout row wrap class="px-1">
                                                <v-flex xs12>
                                                    <h4 class="grey--text text--darken-3">{{  sampleVideo.title }}</h4>
                                                    <div class="caption grey--text font-weight-bold text-truncate">{{
                                                        sampleVideo.description }}</div>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-form>

</template>

<script>
import TextEditor from "@/components/TextEditor";
import DEFINES from '@/defines'
import DateTimePicker from "@/components/DateTimePicker";
import ShowLocalTime from "@/components/ShowLocalTime";
import { mapState, mapGetters } from "vuex";
import VimeoUploader from "@/utils/vimeoUploader";
import rules from "@/validation";
import { utcToTz} from "@/helper";

export default {
    name: 'EventBasicDetails',
    props: {
        draftScreener: {
            type: Object,
            default: null
        }
    },
    components: {
        TextEditor,
        DateTimePicker,
        ShowLocalTime
    },
    data() {
        return {
            rules,
            time: null,
            startTimePicker: false,
            endTimePicker: false,
            formData: {
                title: '',
                description: '',
                screening_starts_at: null,
                screening_ends_at: null,
                max_participants: DEFINES.PREMIUM_SCREENING_MIN_SEATS
            },
            sampleVideo: DEFINES.QUICK_EVENT.SAMPLE_VIDEO.VIMEO,
            videoUploader: {
                isUploading: false,
                isProcessing: false,
                progress: 0,
                status: null,
                hlsUrl: null,
                error: null,
                fileName: null,
                fileSize: null,
                thumbnailUrl: null,
                vimeoId: null
            },
            videoSource: null

        }
    },

    computed: {
        ...mapGetters("company", {
            timezone: "getSelectedCompanyTimezone",
            selected_company_id: "getSelected",
        }),
        uploadingVideoStatus() {
            if(!this.videoUploader.isUploading){
                return null
            }

            if(this.videoUploader.status == 'uploading'){
                return `Uploading (${this.videoUploader.progress}%)`
            }

            if(this.videoUploader.status == 'in_progress'){
                return `Preparing...`
            }

            if(this.videoUploader.status == 'complete'){
                return `Your video is ready for streaming!`
            }
        },

        videoInDraftMode() {
            if(!this.draftScreener || !this.draftScreener.quick_event_configuration){
                return null
            }

            return this.draftScreener.quick_event_configuration
        }
    },
    watch: {
        videoUploader: {
            handler(newValue, oldValue){
                return this.$emit('uploadingVideo', newValue)
            },
            deep: true
        },
        draftScreener: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.draftScreener = newValue
                    this.initiateFormData();
                }
            }
        }
    },
    methods: {
        initiateFormData() {
            if (this.draftScreener) {
                let {title, description, screening_starts_at, screening_ends_at , limitation} = this.draftScreener

                this.formData = {
                    title: title,
                    description: description,
                    screening_starts_at: utcToTz(screening_starts_at, this.timezone),
                    screening_ends_at: utcToTz(screening_ends_at, this.timezone),
                    max_participants:limitation
                }
            }
        },

        openFilePicker(picker_type) {
            if (picker_type == 'video_movie') {
                this.$refs.videoFilePicker.click()
            } else {
                this.$refs.thumbnailFilePicker.click()
            }
        },
        async onCreate() {
            this.$emit('continueNextStep')
        },
        changeVideoSource(source){
            this.videoSource = source;
            this.$emit('videoSourceChanged', source)
        },

        /**
         * On video file selection
         * @param {*} event
         */
        onVideoSelection(event) {
            this.changeVideoSource(this.DEFINES.QUICK_EVENT.VIDEO_SOURCE.UPLOAD)
            const file = event.target.files[0];
            if (file) {
                this.uploadVideo(file);
            }
        },

        /**
         * Handle video file uploading
         * @param {*} file
         */
        async uploadVideo(file) {
            //1. Initialize vimeo helper
            const uploader = new VimeoUploader({
                accessToken: this.DEFINES.VIMEO_ACCESS_TOKEN,
            });


            this.videoUploader.isUploading = true;
            this.videoUploader.status = 'uploading';
            this.videoUploader.fileName = file.name;
            this.videoUploader.fileSize = (file.size / (1024 * 1024)).toFixed(2);
            uploader.uploadVideo(file,
                // Progress callback
                (progress) => {
                    this.videoUploader.progress = progress;
                },
                // Complete callback (Upload + Encoded)
                ({ hlsUrl, thumbnailUrl }) => {
                    console.log('uploaded sussessfully', hlsUrl, thumbnailUrl)
                    this.videoUploader.isUploading = false;
                    this.videoUploader.isProcessing = false;
                    this.videoUploader.hlsUrl = hlsUrl;
                    this.videoUploader.thumbnailUrl = thumbnailUrl;
                    this.$emit("uploadSuccess", { hlsUrl, thumbnailUrl }); // Emit success event with URLs
                },
                // Error Callback
                (error) => {
                    this.videoUploader.error = true
                    this.videoUploader.isUploading = false;
                    this.videoUploader.isProcessing = false;
                    this.$emit("uploadError", error); // Emit error event
                },
                // Status change callback
                (status) => {
                    this.videoUploader.status = `${status}`;
                    this.videoUploader.isProcessing = status !== "complete";
                },

                //After upload callback
                (vimeoId) => {
                    this.videoUploader.vimeoId = vimeoId
                }
            );
        },

        isFormValid() {
            if (!this.$refs.form.validate()) {
                return false;
            }

            return true
        }
    }
}
</script>

<style scoped>
.video-uploader {
    border: 2px solid powderblue !important;
    background-color: rgba(0, 124, 186, 0.04) !important;
    border-radius: 10px !important;
}
.change-video-btn {
    font-size: smaller;
}

.video-source-selected {
    border: 2px solid green !important;
    border-radius: 10px;
}
</style>
